import { baseUrl, headers, jwtFormDataHeaders, jwtHeaders } from '../common/data';

export const fetchAllStaffs = async (branchId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getallstaffbybranch/${branchId}${queryParams ? queryParams : ''}`,
    {
      headers:jwtHeaders(),
    },
  );
  const resData = await response?.json();

  return resData;
};

export const getAllStaff = async (branchId) => {
  const response = await fetch(`${baseUrl}/api/staff/getall/${branchId}`, {
    headers:jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

export const createStaff = async (data) => {
  const response = await fetch(`${baseUrl}/api/staff/create`, {
    method: 'POST',
    body: data,
    headers:jwtFormDataHeaders()
  });
  const resData = await response?.json();

  return resData;
};

export const updateStaff = async (id, data, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/staff/editdetails/${id}${branchId ? branchId : ''}`,
    {
      method: 'PUT',
      body: JSON.stringify(data),
      headers:jwtHeaders(),
    },
  );
  const resData = await response.json();

  return resData;
};

export const deleteStaff = async (id, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/staff/deletestaff/${id}${branchId ? branchId : ''}`,
    {
      method: 'DELETE',
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();

  return resData;
};

export const getStaffById = async (id) => {
  const response = await fetch(`${baseUrl}/api/staff/getastaff/${id}`, { headers:jwtHeaders() });
  const resData = await response?.json();

  return resData;
};

export const fetchAttendanceByStaffId = async (id, queryParmas) => {
  const response = await fetch(
    `${baseUrl}/api/staff/attendance/${id}${queryParmas ? queryParmas : ''}`,
    {
      method: 'GET',
      // headers,
      headers:jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};

export const fetchStaffOverviewData = async (selectedStaffId, queryParmas) => {
  const response = await fetch(
    `${baseUrl}/api/staff/staffoverview/${selectedStaffId}${queryParmas ? queryParmas : ''}`,
    {
      method: 'GET',
      // headers,
      headers:jwtHeaders() 
    },
  );
  const resData = await response?.json();
  return resData;
};

export const staffCollection = async (id, queryParmas) => {
  const response = await fetch(
    `${baseUrl}/api/billing/staffwisesales/${id}${queryParmas ? queryParmas : ''}`,
    {
      method: 'GET',
      // headers,
      headers:jwtHeaders() 
    },
  );
  const resData = await response?.json();
  return resData;
};

export const changeStaffAccountStatus = async (staffId, queryParams, data) => {
  const response = await fetch(
    `${baseUrl}/api/staff/activestatus/${staffId}${queryParams ? queryParams : ''}`,
    {
      method: 'PATCH',
      // headers,
      headers:jwtHeaders(),
      body: JSON.stringify(data),
      redirect: 'follow',
    },
  );
  const resData = await response.json();
  return resData;
};

export const staffStatusUpdate = async (selectedStaffId,queryParams) => {
  const response = await fetch(`${baseUrl}/api/staff/updateattendance/${selectedStaffId}${queryParams}`, {
    method: 'POST',
    headers:jwtFormDataHeaders()
  });
  const resData = await response?.json();

  return resData;
};

export const fetchStaffWiseWork = async (branchId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/staff/staffwisework/${branchId}?${queryParams ? queryParams:''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    }
  );
  const resData = await response?.json();
  console.log(resData,"resData")
  return resData;
};

export const staffWorkAnalysis = async (id, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/staff/staffworkanalysis/${id}${queryParams ? queryParams : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders()
    }
  );
  const resData = await response.json();
  return resData;
};

export const staffOverview = async (id, branchId, month) => {
  const response = await fetch(
    `${baseUrl}/api/staff/staffoverview/${id}?branchId=${branchId}&month=${month}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    }
  );

  const resData = await response.json();
  return resData;
};

export const fetchSalarySlipById = async (staffId, activeBranchId) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getsalaryslip/${staffId}${activeBranchId ? `?branchId=${activeBranchId}` : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    }
  );
  
  const resData = await response?.json();
  return resData;
};

export const fetchStaffAdvanceById = async (staffId, activeBranchId) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getstaffadvance/${staffId}${
      activeBranchId ? `?branchId=${activeBranchId}` : ''
    }`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    },
  );

  const resData = await response?.json();
  return resData;
};

export const fetchStaffIncentiveById = async (staffId, activeBranchId) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getstaffincentive/${staffId}${
      activeBranchId ? `?branchId=${activeBranchId}` : ''
    }`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    },
  );

  const resData = await response?.json();
  return resData;
};

export const setCalendarEntry = async (staffId, data) => {
  const response = await fetch(`${baseUrl}/api/staff/setCalendarEntry/${staffId}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: jwtHeaders(),
  });
  const resData = await response?.json();
  return resData;
};

export const bulkSetCalendar = async (staffId, data) => {
  const response = await fetch(`${baseUrl}/api/staff/bulkSetCalendar/${staffId}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: jwtHeaders(),
  });
  const resData = await response?.json();
  return resData;
};

export const removeCalendarEntry = async (staffId, date) => {
  const response = await fetch(
    `${baseUrl}/api/staff/removeCalendarEntry/${staffId}?date=${date}`,
    {
      method: 'DELETE',
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};

export const getStaffCalendar = async (staffId) => {
  const response = await fetch(`${baseUrl}/api/staff/getStaffCalendar/${staffId}`, {
    method: 'GET',
    headers: jwtHeaders(),
  });
  const resData = await response?.json();
  return resData;
};

export const getStaffCalendarView = async (staffId, month, year) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getStaffCalendarView/${staffId}?month=${month}&year=${year}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};

export const getAllLeaveRequestsByBranch = async (branchId) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getAllLeaveRequestsByBranch/${branchId}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};

export const updateLeaveStatus = async (staffId, leaveId, body) => {
  const response = await fetch(
    `${baseUrl}/api/staff/updateLeaveStatus/${staffId}/${leaveId}`,
    {
      method: 'PATCH', // or PUT, depending on your route registration
      headers: jwtHeaders(),
      body: JSON.stringify(body),
    },
  );
  const resData = await response?.json();
  return resData;
};

export const fetchStaffLeaves = async (staffId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getStaffLeaves/${staffId}${queryParams ? queryParams : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};